import React from "react";
import { Button, TextField, Box, Grid, Typography } from '@material-ui/core';
import authentication from "../../../services/authentication";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useHistory } from "react-router-dom";
import language from "../../../languages";

function ResetPassword(props) {
  const { classes, isSend, lang } = props
  let history  = useHistory();

  function handleSubmit(resetPasswordCredentials) {
      
    authentication
            .resetPassword(resetPasswordCredentials.email)
            .then((value) => {
                // console.log(value)
                props.toggleLoader(false)
                history.push('/initiateResetPassword')
                // setIsSend(true)
                // props.openSnackbar(
                //   `Reset Password initiated`, 'success'
                // );
            })
            .catch((reason) => {
              const code = reason.code;
              const message = reason.message;
              props.toggleLoader(false)

              switch (code) {
                case "auth/invalid-email":
                case "auth/user-disabled":
                case "auth/user-not-found":
                case "auth/wrong-password":
                  props.openSnackbar(message, 'error');
                  return;

                default:
                  props.openSnackbar(message, 'error');
                  return;
              }
            })
            .finally(() => {
            //   this.setState({
            //     performingAction: false,
            //   });
            });
  }

  const validationSchema = Yup.object({
    email: Yup
        .string()
        .email()
        .required(language[lang].Field_Required),
 })

 const initialCredential = {
     email: ''
 }

  const formik = useFormik({
    initialValues: initialCredential,
    enableReinitialize:true,
    validationSchema: validationSchema || Yup.object({}),
    onSubmit: resetPasswordCredentials => {
        props.toggleLoader(true)
        handleSubmit(resetPasswordCredentials)
    },
  });

  return (
    <React.Fragment>

        <form onSubmit={formik.handleSubmit} >
        <div className={classes.root}>
          <Grid container justify="center" spacing={3}>
            <Grid item xs={12} sm={10} md={8} lg={6} className={classes.loginContainer}>
              <Box className={classes.paper} >

                <img src={process.env.PUBLIC_URL + "avvAppLogo.png"} alt="Logo Text" className={classes.image} />
                <Typography variant="h6" gutterBottom>{language[lang].Reset_Password}</Typography>
                <Typography variant="subtitle1" gutterBottom>{language[lang].Reset_Password_Inst}</Typography>
                { isSend ?
                    <Grid container justify="center" alignItems="center" className={classes.inputGrid} >
                        <Grid item xs={12} >
                            <Box className={classes.sendConfirmBox}>
                                <Typography variant="body2" component="p" >
                                  {language[lang].Reset_Password_Thanks} “email@email.com”
                                </Typography> 
                            </Box>
                        </Grid>
                    </Grid>
                  :
                    <Grid container justify="center" alignItems="center" className={classes.inputGrid}>
                        <Grid item xs={4}>   
                        <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Email}:</Typography>
                        </Grid>
                        <Grid item xs={1} ></Grid>
                        <Grid item xs={7}>   
                            <TextField
                            className={classes.singnUpInput}
                            color="secondary"
                            placeholder='sample@gmail.com'
                            id='email'
                            value={formik.values.email}
                            name='email'
                            type="email"
                            size="small"
                            {...formik.getFieldProps('email')}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.errors.email}
                            onChange={formik.handleChange}
                        />
                        </Grid>
                    </Grid>
                }
                {/* <Grid container direction="row" justify="flex-end" alignItems="center" className={classes.forgotText}  >
                  <Typography variant="body2" > Forgotten your password? </Typography>
                  <Button size="small" className={classes.resetButton} >
                    Reset Password.
                  </Button>
                </Grid> */}

                <Grid container direction="row" justify="center" alignItems="center"> 
                { isSend ?
                    <Button variant="contained" size="large" onClick={() => history.push('/login')} className={classes.resetSubmitButton}>
                        {language[lang].Login} &nbsp; &nbsp; &nbsp; &nbsp; <ArrowForwardIosIcon fontSize="small" />
                    </Button>
                  :
                    <Button variant="contained" size="large" type="submit" className={classes.resetSubmitButton}>
                        {language[lang].Reset} &nbsp; &nbsp; &nbsp; &nbsp; <ArrowForwardIosIcon fontSize="small" />
                    </Button>
                }
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center" className={classes.registerText}  >
                  <Typography variant="body2" > {language[lang].No_Account} </Typography>
                  <Button size="small" className={classes.resetButton} onClick={() => history.push('/signUp')}   >
                    {language[lang].Register_account}
                  </Button>
                </Grid>

              </Box>
            </Grid>
          </Grid>
        </div>
        </form>
      
    </React.Fragment>
  );
}

export default ResetPassword